const additionalInfoRule = ({ additional = {}, layoutVariant = '' }) => ({ item }) => {
  if (layoutVariant === item.layoutVariant) {
    return {
      item,
      ...additional
    }
  }
}
export default additionalInfoRule
